module.exports = __webpack_public_path__ + "img/img39.dd6f26f6.png";